import {useUrlState} from "../../../../../lib/utils.ts";
import {SetURLSearchParams} from "react-router-dom";

export interface MatchesPageState {
    businessId: string | null;
    startDate: string;
    endDate: string;
}

const BUSINESS_ID_PARAM = 'clientId';
const START_DATE_PARAM = 'from';
const END_DATE_PARAM = 'to';

function serialize(params: URLSearchParams): MatchesPageState {
    return {
        businessId: params.get(BUSINESS_ID_PARAM),
        startDate: params.get(START_DATE_PARAM) || '',
        endDate: params.get(END_DATE_PARAM) || '',
    };
}

export function deserializeMatchesPageState(newState: MatchesPageState): URLSearchParams {
    const newQueryParameters: URLSearchParams = new URLSearchParams();

    if (newState.businessId) {
        newQueryParameters.set(BUSINESS_ID_PARAM, newState.businessId);
    }

    if (newState.startDate !== null && newState.startDate !== undefined && newState.startDate !== '') {
        newQueryParameters.set(START_DATE_PARAM, newState.startDate);
    }

    if (newState.endDate !== null && newState.endDate !== undefined && newState.endDate !== '') {
        newQueryParameters.set(END_DATE_PARAM, newState.endDate);
    }

    return newQueryParameters;
}

export function useMatchesPageState(params: URLSearchParams, setParams: SetURLSearchParams) {
    return useUrlState<MatchesPageState>(params, setParams, serialize, deserializeMatchesPageState);
}
